export const priceFormat = (price: number) => {
  const euro = Intl.NumberFormat('el', {
    style: 'currency',
    currency: 'EUR',
  });
  return euro.format(price);
};

export const decimalFormat = (number: number) => {
  const percentage = Intl.NumberFormat('el-GR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2});
  const value = percentage.format(number);
  return value;
};

export const sanitizeUppercase = (string: string) => {
  let sanitizedString = '';

  for (let i = 0; i < string.length; i++) {
    sanitizedString += string[i]
      .replace(/ά|Ά/g, 'α')
      .replace(/έ|Έ/g, 'ε')
      .replace(/ή|Ή/g, 'η')
      .replace(/ί|Ί/g, 'ι')
      .replace(/ό|Ό/g, 'ο')
      .replace(/ύ|Ύ/g, 'υ')
      .replace(/ώ|Ώ/g, 'ω')
      .replace(/ς/g, 'σ');
  }

  return sanitizedString.toUpperCase();
};

export const slugify = (str: string) => {
  const a =
    'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;αβγδεζηικλμνξοπρσςτυφχωάέήίόύώϊϋΐΰ';
  const b =
    'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------abgdeziiklmnxoprsstufxoaeiioyoiiy';
  const p = new RegExp(a.split('').join('|'), 'g');

  return str
    .toString()
    .toLowerCase()
    .replace(/ψ|Ψ/g, 'ps')
    .replace(/θ|Θ/g, 'th')
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
};
